import { POPULAR_AUSTRALIAN_AIRPORTS } from 'constants/flight'
import { uniqueBy } from 'lib/array/arrayUtils'

export const RECENT_AIRPORTS_HEADING = 'Recent searches'
export const POPULAR_AIRPORTS_HEADING = 'Popular airports'

interface Options {
  /** Airports kept at the top of the list, e.g. the previous leg's arrival airport */
  pinnedAirports?: Array<App.AirportLocation>;
  /** Airport selected in the other direction, left out of the list */
  excludeAirport?: App.AirportLocation;
}

export interface AirportSuggestions {
  airports: Array<App.AirportLocation>;
  heading: string;
}

// Recent searches when the user has any, otherwise the popular Australian airports
export function getAirportSuggestions(
  recentAirports: Array<App.AirportLocation>,
  options: Options = {},
): AirportSuggestions {
  const { pinnedAirports = [], excludeAirport } = options
  const hasRecent = recentAirports.length > 0
  const base = hasRecent ? recentAirports : POPULAR_AUSTRALIAN_AIRPORTS
  const airports = uniqueBy([...pinnedAirports, ...base], airport => airport.airportCode)
    .filter(airport => airport.airportCode !== excludeAirport?.airportCode)

  return {
    airports,
    heading: hasRecent ? RECENT_AIRPORTS_HEADING : POPULAR_AIRPORTS_HEADING,
  }
}
